import { ShowContextProvider, Title, useEditController } from "react-admin";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { IdChip } from "../../components/IdChip";
import { ReviewedChip } from "../../components/ReviewedChip";
import { showLabelSx } from "../../components/listStyles";
import { colors } from "../../data/tokens";

// Ficha no padrão do painel: nome em destaque com a situação de revisão
// e o identificador técnico copiável — a versão antiga listava "Id",
// "Nome" e um ✓ solto, empilhados.
export const GraduationShow = () => {
  const { id } = useParams();
  const controller: any = useEditController({
    resource: "graduations/crud",
    id,
  });
  const record = controller?.record;

  return (
    <ShowContextProvider value={controller}>
      <Title title="Formações" />
      <PageTopBreadcrumb
        title="Formações"
        firstPath="/#/graduations/crud"
        secondTitle="Visualizando"
        thirdTitle={record?.name}
        actionType="edit"
      />
      {record && (
        <Card sx={{ marginBottom: 3 }}>
          {/* Box em vez de CardContent: o App.css zera o padding de todo
              .MuiCardContent-root com !important */}
          <Box sx={{ padding: { xs: 2.5, md: 4 } }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                flexWrap: "wrap",
              }}
            >
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: colors.primaryDark,
                }}
              >
                {record.name}
              </Typography>
              <ReviewedChip reviewed={record.reviewed} />
            </Box>
            <Typography
              sx={{ fontSize: 12.5, color: colors.textMuted, marginTop: 1 }}
            >
              Formações revisadas aparecem primeiro nas listas de seleção do
              cadastro do sócio.
            </Typography>

            <Divider sx={{ marginY: 2.5 }} />

            <Typography sx={showLabelSx}>Identificador técnico</Typography>
            <Box sx={{ marginTop: 0.5 }}>
              <IdChip value={record.id} />
            </Box>
          </Box>
        </Card>
      )}
    </ShowContextProvider>
  );
};
